export enum ApproverStatus {
  Created,
  WaitingForApproval,
  Approved,
  Rejected
}
